export default function getProductTypeLabel(name) {
  if (name === "main") return "Hauptkomponente";
  if (name === "builtin") return "Integriert";
  if (name === "loc") return "Lokalisierung";

  return name;
}
